import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import StartWritingDialog from '@/components/progress/dialogs/StartWritingDialog.vue';
import StartPostingDialog from '@/components/progress/dialogs/StartPostingDialog.vue';
import StartVotingDialog from '@/components/progress/dialogs/StartVotingDialog.vue';
import StartDiscussionDialog from '@/components/progress/dialogs/StartDiscussionDialog.vue';
import NextGroupDialog from '@/components/progress/dialogs/NextGroupDialog.vue';
import StartReviewDialog from '@/components/progress/dialogs/StartReviewDialog.vue';
import FinishRetroDialog from '@/components/progress/dialogs/FinishRetroDialog.vue';
import ChooseReviewOrNextGroupDialog from './dialogs/ChooseReviewOrNextGroupDialog.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ProgressDialogs',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(StartWritingDialog),
                _createVNode(StartPostingDialog),
                _createVNode(StartVotingDialog),
                _createVNode(StartDiscussionDialog),
                _createVNode(ChooseReviewOrNextGroupDialog),
                _createVNode(NextGroupDialog),
                _createVNode(StartReviewDialog),
                _createVNode(FinishRetroDialog)
            ]));
        };
    }
});
